// extracted by mini-css-extract-plugin
export var navbar = "navBar-module--navbar--6SdYD";
export var textCenter = "navBar-module--textCenter--2nHYs";